import React from 'react';



export default function BuyerMapEd() {

  return (
    <>
        <h1>СТРАТЕГИЧЕСКАЯ КАНВА ТЕКУЩЕГО ПОЛОЖЕНИЯ ДЕЛ В ОТРАСЛИ</h1>
        <p>Cтратегическая канва текущего положения дел в отрасли – визуальный аналитический инструмент, который иллюстрирует мнение членов команды о том, по каким факторам конкурирует отрасль, и уровень предложения конкурентов по данным факторам.</p>
        <img src={`${process.env.PUBLIC_URL}/images/1. As-Is-ru.jpg`} style={{width: 600}}/>
        <h3>
          Канва содержит следующие элементы:
        </h3>
        <p>
          1. Факторы конкурентной борьбы (горизонтальная ось) – это основные факторы, по которым конкурирует ваше направление бизнеса или продукт.
        </p>

        <p>
          2. Уровень предложения (вертикальная ось), которое получают потребители по каждому ключевому фактору конкуренции в отрасли.
        </p>

        <p>
          3. Стратегический профиль конкурента – линия, соединяющая уровни предложения. Это графическое изображение эффективности компании по всем ключевым факторам конкуренции.
        </p>
        <p>
          Цель инструмента – обозначить, как члены команды видят текущее положение дел в отрасли. В итоге команда понимает, что получают потребители от конкурентных предложений в текущий момент.
        </p>

        <h3>
          Алгоритм работы с инструментом:
        </h3>

        <p>
          1. Назовите свою отрасль, в которой конкурирует выбранное вами направление бизнеса или продукт, а в случае стартапа - отрасль, в которую хотите войти.
        </p>
        <p>
          2. Перечислите ключевые факторы, по которым, на ваш взгляд, конкурирует отрасль с точки зрения потребителя.
        </p>
        <p>
          3. Выберите ключевых участников отрасли, с которым вы будете себя сравнивать.
        </p>
        <p>
          4. Оцените предложение лучших участников отрасли по ключевым факторам конкуренции.
        </p>
        <p>
          5. Постройте текущую стратегическую канву – по горизонтали разместите факторы конкуренции, по вертикали отметьте уровень предложения по данным факторам и соедините точки.
        </p>

        <h3>
          Правила работы с инструментом:
        </h3>

        <p>
          1. Ключевых факторов конкуренции должно быть не менее 5 и не более 12. В случае коммерческих компаний цена обязательно должна находиться в списке ключевых факторов конкуренции.
        </p>
        <p>
          2. В качестве основных факторов конкуренции выбирайте те факторы, которые имеют значение для потребителей. Называйте факторы словами из языка потребителей, а не из языка технических терминов продукта.
        </p>




    </>
  )
}
